function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Rect, Text, TSpan, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(G, {
  transform: "translate(.5 .5)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Rect, {
  width: 43.478,
  height: 43.458,
  fill: "#5B41F0",
  rx: 13
}), /*#__PURE__*/React.createElement(Text, {
  fill: "#FFF",
  fontFamily: "HalisR-Bold, Halis R",
  fontSize: 16,
  fontWeight: "bold",
  letterSpacing: -0.333,
  transform: "translate(9.034 9.04)"
}, /*#__PURE__*/React.createElement(TSpan, {
  x: 8.797,
  y: 18.133
}, "1")), /*#__PURE__*/React.createElement(Path, {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M9.034 17.375V12.94a3.9 3.9 0 013.9-3.9h4.433m9.172 0h4.436a3.901 3.901 0 013.899 3.9v4.435m0 9.171v4.435a3.9 3.9 0 01-3.9 3.899h-4.435m-9.172 0h-4.433a3.9 3.9 0 01-3.9-3.9v-4.434"
}));

function SvgIconFirstPlanActive(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45
  }, props), _ref);
}

export default SvgIconFirstPlanActive;